<script setup lang="ts">
export interface Props {
  backgroundImageUrl: string;
  header: string;
  showAccountMessage?: boolean;
}

withDefaults(defineProps<Props>(), {
  showAccountMessage: false,
});
</script>

<template>
  <div
    class="background-image-wrapper"
    :style="{ backgroundImage: `url(${backgroundImageUrl})` }"
    data-cy="background-image">
    <div class="bkg-container">
      <div class="header-area">
        {{ header }}
      </div>
      <div class="content-container">
        <main class="content-wrapper" data-cy="login-form">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.background-image-wrapper {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  display: flex;
  align-items: center;

  .bkg-container {
    @include main-max-with;

    padding: 40px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    width: 100%;

    align-items: center;

    .header-area {
      color: white;
      text-align: left;
      max-width: 400px;
      font-size: 42px;
      font-weight: 400;
    }

    .content-container {
      width: 440px;

      .content-wrapper {
        border-radius: 6px;
        background: var(--primary-bg-color);

        @media only screen and (min-width: 560px) {
          padding: 1rem 1.5rem;
          margin: 0 auto;
        }
      }
    }
    .create-account {
      display: block;
      font-size: 1rem;
      margin: 2rem 0 2rem auto;
      line-height: 150%;
      color: #fff;
      width: 440px;
      grid-column: 2;

      .contact-link {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
}
</style>
